module.exports = __webpack_public_path__ + "static/media/menu_icon_mofftre_normal.46d0be07.png";